/**
 * Created by razial on 27.05.2025.
 */

const GameLevelHelper = {
    initialized: true,

    main: undefined,

    Initialize: function () {
        this.initialized = true;

        this.main = new GameLevel();
        this.main.load();

        cleverapps.gameLevel = this.main;
    },

    Switch: function (locationId) {
        if (!this.initialized) {
            return;
        }

        if (cleverapps.gameLevel !== this.main) {
            cleverapps.gameLevel.destructor();
        }

        const locationMeta = cleverapps.meta.getLocationMeta(locationId);
        const locationConfig = locationMeta.locationConfig;

        if (locationConfig.withOwnGameLevel) {
            cleverapps.gameLevel = new GameLevel(locationConfig);
            cleverapps.gameLevel.load();
        } else {
            cleverapps.gameLevel = this.main;
        }
    },

    GetMainInstance: function () {
        return this.main;
    }
};